import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Stethoscope, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Senha redefinida com sucesso!");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="h-10 w-10 rounded-2xl bg-emerald-500 flex items-center justify-center">
            <Stethoscope className="h-5 w-5 text-white" />
          </div>
          <span className="font-display font-extrabold text-slate-900 text-xl">ZAP DOUTOR</span>
        </div>
        <h2 className="font-display text-2xl font-bold text-slate-900">Nova senha</h2>
        <p className="text-sm text-slate-500 mt-1 mb-6">Defina uma nova senha para sua conta.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="password">Nova senha</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="mt-1.5" data-testid="reset-password-input" />
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <Button type="submit" disabled={loading || !token} className="w-full bg-emerald-500 hover:bg-emerald-600 h-11" data-testid="reset-submit-button">
            {loading ? "Salvando..." : "Redefinir senha"}
          </Button>
        </form>
        <Link to="/login" className="inline-flex items-center gap-2 text-slate-500 hover:text-slate-700 text-sm mt-6">
          <ArrowLeft className="h-4 w-4" /> Voltar para o login
        </Link>
      </div>
    </div>
  );
}
